import api from '../../api/axiosInstance';

export interface AiProviderConfig {
  provider: string; // 'aws' | 'azure' | 'openai'
  awsAccessLevel?: string; // 'subscription' | 'direct'
  label?: string;
  model?: string;
  endpoint?: string;
  apiKey?: string;
  apiSecret?: string;
  sessionToken?: string;
  region?: string;
  apiVersion?: string;
}

export interface AiSettingsData {
  id?: string;
  llmMode: string; // 'local' | 'enterprise'
  enterpriseProvider?: string; // 'aws' | 'azure' | 'openai'
  enterpriseAwsAccessLevel?: string; // 'subscription' | 'direct' (aws only)
  // Flattened active-provider fields (also used to submit a provider config)
  enterpriseEndpoint?: string;
  enterpriseApiKey?: string;
  enterpriseApiSecret?: string;
  enterpriseSessionToken?: string;
  enterpriseModel?: string;
  enterpriseRegion?: string;
  enterpriseApiVersion?: string;
  historyEnabled?: boolean;
  historyRetentionDays?: number;
  mcpToolsEnabled?: boolean;
  maxResponseTokens?: number;
  updatedAt?: string;
  // All saved provider configs (returned by GET) so the UI can prefill each
  providers?: AiProviderConfig[];
}

export const aiSettingsService = {
  get: async (): Promise<AiSettingsData> => {
    const resp = await api.get('/api/ai/settings');
    return resp.data;
  },

  update: async (settings: Partial<AiSettingsData>): Promise<AiSettingsData> => {
    const resp = await api.put('/api/ai/settings', settings);
    return resp.data;
  }
};
